import React, { useRef, useEffect, useState } from "react"
import { Link as LinkScroll, animateScroll as scroll } from "react-scroll"

import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"
import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"

import BackgroundImage from "gatsby-background-image"
import Zbrush from "../../images/zbrush-logo.svg"

//Breakpoints
import { device } from "../../utils/breakpoints"
import { anims, colors } from "../../utils/theme"

import Modal from "react-bootstrap/Modal"
import FormDudas from "../temario/FormDudas"
import Counter from "../general/Counter"
import ModalTrailer from "../ModalTrailer"

//Imagenes
import Icon from "../../images/list-icon.svg"
import Play from "../../images/play-icon.svg"
import MailchimpForm from "./MailchimpForm"

const HeroImage = styled(BackgroundImage)`
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-position: bottom center;
  background-repeat: no-repeat;
  background-color: rgb(73 0 125 / 80%);
  min-height: 100vh;
  opacity: inherit !important;
  padding-top: 4rem;
  @media ${device.md} {
    padding-top: 0;
    height: 100vh;
    width: 100%;
    background-position: bottom center;
    background-repeat: none;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding-bottom: 10vh;
  }
  .button {
    border: 0;
    padding: 10px 20px;
    border-radius: 10px;
    &-drive {
      background: ${colors.sColor};
      color: ${colors.pColor};
    }
    &-register {
      background: white;
      color: ${colors.pColor};
      font-weight: 700;
      &:hover {
        background: ${colors.sColor};
        color: ${colors.pColor};
      }
    }
  }
  & .call-to-action {
    position: relative;
    @media ${device.md} {
    }
    & .title {
      padding: 2rem 0 0rem 0;
      text-align: center;
      color: white;
      font-weight: 800;
      text-transform: uppercase;
      margin: 0;
      font-style: italic;
      font-size: 1em;
      & span {
        padding: 0.4em 1em;
        position: relative;
        z-index: 2;
        &::before {
          content: "";
          width: 100%;
          height: 100%;
          background: ${colors.pColor};
          transform: skew(-7deg);
          position: absolute;
          left: 0;
          top: 0;
          z-index: -1;
        }
        &::after {
          content: "";
          width: 100%;
          height: 100%;
          border: 2px solid white;
          transform: skew(-10deg);
          position: absolute;
          left: 0;
          top: 0;
          z-index: 1;
          box-shadow: 0 0 20px ${colors.sColor};
        }
      }
      @media ${device.md} {
        font-size: 1.7em;
      }
      @media ${device.lg} {
        font-size: 1.9em;
      }
      @media ${device.xl} {
        font-size: 2.1em;
      }
    }
    & .cyberpunk {
      font-family: "sketter";
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: uppercase;
      font-size: 1.5em;
      position: relative;
      padding: 3rem;
      margin-bottom: 0;
      &-first {
        display: block;
        text-align: center;
        color: white;
        z-index: 2;
        left: 50%;
        transform: translateX(-50%);
        position: absolute;
        text-shadow: 0 0 10px rgba(0, 0, 0, 1);
        &::after {
          content: "";
          top: -10px;
          left: 50%;
          width: 100%;
          height: 3px;
          transform: translateX(-47%);
          background: ${colors.sColor};
          position: absolute;
          border-radius: 6px;
          box-shadow: 0 0 20px ${colors.sColor};
          z-index: 3;
        }
        &::before {
          content: "";
          bottom: -10px;
          left: 50%;
          width: 100%;
          height: 3px;
          transform: translateX(-47%);
          background: ${colors.sColor};
          position: absolute;
          border-radius: 6px;
          box-shadow: 0 0 20px ${colors.sColor};
          z-index: 3;
        }
      }
      &-second {
        display: block;
        text-align: center;
        z-index: 1;
        color: ${colors.pColor};
        left: 50%;
        transform: translate(-49%, 5px);
        position: absolute;
        text-shadow: 0 0 20px ${colors.sColor};
      }
      @media ${device.md} {
        font-size: 2em;
      }
      @media ${device.lg} {
        font-size: 2.6em;
      }
    }
    & .inicia {
      text-align: center;
      margin-bottom: 0;
      &-title {
        display: block;
        color: white;
        font-weight: 700;
        font-size: 0.8em;
        font-style: italic;
        & span {
          background: ${colors.sColor};
          padding: 0.3em 1em;
          color: ${colors.pColor};
        }
      }
      &-date {
        display: inline-block;
        font-family: "sketter";
        padding: 0.6em 0.9em;
        border: 3px solid ${colors.sColor};
        margin: 0.3em auto;
        color: white;
        font-size: 0.6em;
        box-shadow: 0 0 10px ${colors.sColor};
        position: relative;
        &::after {
          content: "";
          width: 10px;
          height: 10px;
          border: 2px solid ${colors.sColor};
          position: absolute;
          left: -20px;
          top: 50%;
          transform: translateY(-50%);
          box-shadow: 0 0 2px ${colors.sColor};
        }
        &::before {
          content: "";
          width: 10px;
          height: 10px;
          border: 2px solid ${colors.sColor};
          position: absolute;
          right: -20px;
          top: 50%;
          transform: translateY(-50%);
          box-shadow: 0 0 2px ${colors.sColor};
        }
      }
    }
    & p {
      color: white;
      font-size: 1em;
      font-weight: 600;
    }
  }
  & h4 {
    font-weight: 800;
    color: white;
    text-transform: uppercase;
    margin-top: 1rem;
    & span {
      border-top: 2px solid white;
      border-bottom: 2px solid white;
    }
  }
  & h5 {
    font-weight: 800;
    color: white;
    text-transform: uppercase;
    margin-top: 1rem;
    & .price {
      margin: 0 5px;
    }
    & .price-antes {
      text-decoration: line-through;
      color: #cacaca;
    }
    & .price-despues {
    }
  }
  & ul {
    list-style: none;
    padding-top: 1rem;
    margin: 0 auto;
    padding-left: 0;
    @media ${device.md} {
    }
    li {
      color: white;
      position: relative;
      text-align: center;
      & strong {
        background: ${colors.sColor};
        color: ${colors.pColor};
        padding: 0 0.5em;
        border-radius: 4px;
      }
      &::before {
        content: "";
        display: none;
        position: absolute;
        left: 0;
        top: 50%;
        background-image: url(${Icon});
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        transform: translateY(-50%);
        width: 20px;
        height: 20px;
      }
    }
  }
  & .information {
    position: absolute;
    bottom: 1rem;
    transform: translateX(-50%);
    left: 50%;
    color: white;
    z-index: 10;
    padding: 0.5em 2em;
    background: ${colors.sColor};
    color: ${colors.pColor};
    font-weight: 700;
    cursor: pointer;
    box-shadow: 0 0 10px ${colors.sColor};
    font-size: 0.8em;
    bottom: 3rem;
    ${anims.transition};
    text-decoration: none;
    @media ${device.md} {
      bottom: 7rem;
      font-size: 1em;
    }
    &:hover {
      background: ${colors.pColor};
      color: ${colors.sColor};
      padding: 0.6em 2.5em;
      box-shadow: 0 0 10px ${colors.pColor};
    }
  }
`

const Fecha = styled.div`
  color: white;
  font-weight: 700;
  text-align: left;
  margin-bottom: 2.5rem;
  & span {
    color: #cfcfcf;
  }
  @media (max-width: 768px) {
    text-align: center;
  }
`

const Hero = () => {
  const [modalForm, setModalForm] = useState(false)

  const { image } = useStaticQuery(graphql`
    query {
      image: file(relativePath: { eq: "hero.png" }) {
        sharp: childImageSharp {
          fluid(quality: 80, maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const [openTrailer, setOpenTrailer] = useState(null)
  const handleTrailer = () => {
    setOpenTrailer(true)
  }
  const handleCloseModal = e => {
    if (modalContent.current && !modalContent.current.contains(e.target)) {
      setOpenTrailer(false)
    }
  }
  const closeModal = e => {
    setOpenTrailer(false)
  }
  let modalContent = useRef(null)
  let callToAction = useRef(null)
  let title = useRef(null)


  const [sizeWindow, setSizeWindow] = useState(null);
  useEffect(() => {
    const w = window;
    const size = w.innerWidth;
    if( size > 768 ){
      setSizeWindow('big');
      setOpenTrailer(true);
    }else{
      setSizeWindow('mobile');
      setOpenTrailer(false);
    }
  }, [])

  return (
    <>
      <HeroImage
        tag="section"
        fluid={image.sharp.fluid}
        fadeIn="soft"
        backgroundColor={`#5d01bd`}
      >
        <Container className="h-100">
          <Row className="align-items-center  h-100">
            <Col md={7} className="center">
              <div
                className="call-to-action"
                ref={el => {
                  callToAction = el
                }}
              >
                <img
                  src={Zbrush}
                  style={{ width: "80px", display: "block", margin: "0 auto" }}
                />
                <h1
                  className="title text-center"
                  ref={el => {
                    title = el
                  }}
                >
                  <span>Curso/Reto</span>
                </h1>
                <h2 className="cyberpunk text-center">
                  <span className="cyberpunk-first">CYBERPUNK</span>
                  <span className="cyberpunk-second">CYBERPUNK</span>
                </h2>
                <h3
                  className="inicia text-center"
                  style={{ position: "relative"}}
                >
                  <span className="inicia-title">
                    {" "}
                    <span>LIVE INFORMATIVO:</span> <br></br>
                  </span>
                  <span className="inicia-date"> 13 DE MARZO </span>
                </h3>
                <h3 className="inicia text-center">
                  <span
                    className="inicia-title"
                    style={{ marginBottom: "5px", fontSize: ".5em" }}
                  >
                    <span>Sábado 3:00P.M. (Hora Col) </span>
                  </span>
                </h3>
                <Counter date={"Mar 13, 2021 0:0:0"} />
                <img
                    src={Play}
                    style={{
                      width: "100px",
                      height: "auto",
                      margin: "0 auto",
                      display: "block",
                      cursor: "pointer",
                      zIndex: 1,
                    }}
                    onClick={handleTrailer}
                  />
                {/* <h5 className="text-center">
                  <span className="price price-antes">$149Usd.</span>/
                  <span className="price price-despues">$69Usd.</span>
                </h5> */}
                <h4 className="text-center">
                  <span>Becas al 100%</span>
                </h4>
                <ul>
                  <li>Personajes Videojuegos AAA</li>
                  <li>Soldados Videojuegos AAA</li>
                  <li>
                    <strong>Curso premium lanzamiento</strong>
                  </li>
                </ul>
              </div>
            </Col>
            <Col md={5}>
              <MailchimpForm />
            </Col>
          </Row>
        </Container>
      </HeroImage>
      <ModalTrailer
        modalState={openTrailer}
        closeTrailer={handleCloseModal}
        closeModal={closeModal}
        forwardRef={modalContent}
      />
    </>
  )
}

export default Hero
